<template>
  <div class="footer">
    <div class="title">
      <span @click="go('/')">首页</span>     |     <span @click="go('/hospitalList')">PETCT/MR中心</span>    |     <span @click="go('/hospitalList2')">推荐专家</span>     |     <span @click="go('/zx')">PETCT/MR资讯</span>     |     <span @click="go('/PET_TC_zx')">预约指南</span>
    </div>
    <div class="box">
      <div class="content">
        <div class="left">
          <p>网络在线预约</p>
          <p class="p2">PETCT/MR预约平台</p>
        </div>
        <div class="cen1">
          <div>
            <img :src="wximg" alt="">
            关注微信
          </div>
          <div>
            <img :src="appimg" alt="">
            APP下载
          </div>
        </div>
        <div class="cen2">
          <el-button class="foot-btn" @click="yyhz">医院合作</el-button>
          <el-button class="foot-btn" @click="qdhz" style="margin-left: 0;">合作伙伴</el-button>
        </div>
        <div class="right">
          <p class="tit">合作伙伴</p>
          <p>
            <span class="item" v-for="item in hzlist" :key="item.id"><a :href="item.url" target="_blank">{{item.name}}</a></span>
          </p>
        </div>
      </div>
    </div>
    <div class="ip">
      <template v-for="item in iplist">
        <!--<img src="@/assets/image/25.png" alt="">-->
        <a :key="item.id" :href="item.url" target="_blank">{{item.name}}</a>
      </template>
    </div>
    <!--<div class="line"></div> <a target="_blank" :href="vipurl" style="color: #cac8c8">{{vip}}</a>-->
    <p class="bz">{{footname}} </p>
    <div  class="imgbox" style="display: flex; justify-content: space-between;width: 1370px;">
      <!--<a><img src="@/assets/image/25.png" alt="" ></a>-->
      <!--<a><img src="@/assets/image/25.png" alt="" ></a>-->
      <!--<a><img src="@/assets/image/25.png" alt="" ></a>-->
      <template v-for="item in list" >
        <a :href="item.url" target="_blank" :key="item.id"><img :src="item.picUrl" alt="" ></a>
      </template>
    </div>
  </div>
</template>

<script>
  import server from '@/service/server.js'
export default {
    name: 'footer',
  data () {
    return {
      input3: '',
      select: '',
      list: [],
      hzlist: [],
      iplist: [],
      ipname: '',
      appimg: '',
      vip: '',
      vipurl: '',
      wximg: '',
      footname: ''
    }
  },
    methods: {
      // toTop() {
      //   document.documentElement.scrollTop = 0;
      // },
      go(path) {
        this.$router.push(path)
      },
      yyhz() {
        this.$router.push({
          path: `/yyhz`
        })
      },
      qdhz() {
        this.$router.push({
          path: `/qdhz`
        })
      }


    },
    mounted() {
      server.intelligence().then((res) => {
        console.log(res.data)
        this.list = res.data
      })
      server.recordList().then((res) => {
        this.iplist = res.data
      })
      server.getVipRecords().then((res) => {
        this.vip = res.data.introduction
        this.vipurl = res.data.url
      })
      server.getAppQrCode().then((res) => {
        this.appimg = res.data.picUrl
      })
      server.getWeChatQrCode().then((res) => {
        this.wximg = res.data.picUrl
        // document.getElementById('kfimg').src = this.wximg
      })
      server.getServiceQrCode().then((res) => {
        document.getElementById('kfimg').src = res.data.picUrl
      })
      server.getAPPointmentQrCode().then((res) => {
        document.getElementById('yyimg').src = res.data.picUrl
      })
      server.partnerList().then((res) => {
        this.hzlist = res.data
      })
      server.getCompanyName().then((res) => {
        this.footname = res.data.introduction
      })
    },
    computed: {

    }
}
</script>
<style lang="scss" scoped>
  .footer {
    width: 100%;
    .title {
      background-color: #F0F0F0;
      height: 50px;
      line-height: 50px;
      color: #888888;
      text-align: center;
      span {
        margin: 0 20px;
      }
    }
    .content {
      width: 1370px;
      display: flex;
      margin: 0 auto;
    }
    .box {
      position: relative;
      background-color: #FFFFFF;
      width: 100%;
      padding: 20px;
      .left {
        width: 300px;
        height: 120px;
        border-right: 1px solid #CB0E07;
        color: #CB0E07;
        font-size: 16px;
        text-align: center;
        .p2 {
          font-size: 24px;
          padding-top: 15px;
        }
      }
      .cen1 {
        display: flex;
        text-align: center;
        div {
          margin: 0 15px;
          color: #888888;
        }
        img {
          width: 90px;
          height: 90px;
          margin-bottom: 10px;
          display: block;
        }
      }
      .cen2 {
        width: 180px;
        margin-left: 50px;
        text-align: center;
        .foot-btn {
          width: 180px;
          font-size: 20px;
          margin: 10px 0;
          display: block;
          color: #FFFFFF;
          background-color: #CB0E07;
        }
      }
      .right {
        width: 530px;
        margin-left: 60px;
        color: #888;
        font-size: 18px;
        line-height: 30px;
        .item {
          display: inline-block;
          margin: 10px;
          a {
            color: #888;
          }
        }
        .tit {
          /*margin-bottom: 10px;*/
          font-weight: bold;
        }
      }
    }
  .toTop {
    position: fixed;
    top: 360px;
    cursor: pointer;
    left: 50%;
    margin-left: 700px;
    .imgbox2 {
      width: 60px;
      height: 60px;
      margin: 2px 0;
      border: 1px solid #f5f5f5;
      background-color: #FFFFFF;
      position: relative;
      &:hover {
        color: #2593E7;
        .itembox {
          display: block !important;
        }
      }
      &.ac {
        background-color: #2593E7;
        color: #FFFFFF;
      }
      .img1 {
        margin: 4px auto;
      }
      .img2 {
        margin: 6px auto;
      }
      p {
        font-size: 12px;
        text-align: center;
      }
      .itembox {
        padding: 20px;
        background: #ffffff;
        width: 200px;
        position: absolute;
        right: 60px;
        top: 0px;
        display: none;
        text-align: center;
        font-size: 14px;
        transition: all 0.5s;
        border: 1px solid #f5f5f5;
        span {
          display: block;
        }
      }
    }
    img {
      display: block;
    }
  }
    .ip {
      margin-top: 10px;
      text-align: center;
      color: #888888;
      font-size: 14px;
      margin-bottom: 20px;
      a {
        display: inline-block;
        vertical-align: middle;
        margin:0 5px;
        color: #cccccc;
        &:hover {
          color: #CB0E07;
        }
      }
    }
    .line {
      height: 1px;
      width: 1450px;
      background-color: #EFEFEF;
      margin: 10px auto;
    }
    .bz {
      font-size: 14px;
      color: #CAC8C8;
      text-align: center;
      /*padding-bottom: 50px;*/
    }
    .imgbox {
      margin: 40px auto;
      img {
        height: 41px;
        display: inline-block;
      }
    }
  }
  @media (max-width: 750px) {
    .footer {
      .title {
        display: none;
      }
      .box {
        display: none;
      }
      .content {
        display: block;
        width: 100%;
          .left {
            margin: 0 auto;
            border: none;
          }
        .cen1 {
          display: none;
        }
        .cen2 {
          margin: 0 auto;
        }
        .right {
          width: 100%;
          margin-left: 0;
        }
      }
      .imgbox{
        display: none !important;
      }

    }
  }
</style>
